import { Metamodel } from 'app/model/base/model';
import { IModel, IAttribute } from 'app/model/base/annotation';
import { CompressionReadSettings } from './compression-read-settings';

import { compressionCodecType } from 'shell-models-lib';

@Metamodel.model({
    name: 'ZipDeflateReadSettings',
    display: [],
    tags: { compressionType: compressionCodecType.ZipDeflate }
})

export abstract class ZipDeflateCompressionReadSettings extends CompressionReadSettings {
    public static readonly MODEL: IModel;
    public static readonly PRESERVE_ZIPFILE_NAME_AS_FOLDER: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'PRESERVE_ZIPFILE_NAME_AS_FOLDER',
        display: stringResources.ModelName_PreserveZipFileNameAsFolder
    })
    public preserveZipFileNameAsFolder: boolean;
}
